import React from 'react'

interface LazySectionProps {
  children: React.ReactNode
  /** Kept for API compatibility — no longer used (always render children for SEO/prerender). */
  skeleton?: React.ReactNode
  rootMargin?: string
  /** Minimum height for the wrapper to prevent layout shift. */
  minHeight?: string
}

/**
 * Wrapper that always renders children. Previously used IntersectionObserver for lazy loading,
 * but that caused skeleton placeholders to appear in prerendered HTML. Now renders content
 * immediately for clean SEO output and correct react-snap snapshot.
 */
const LazySection: React.FC<LazySectionProps> = ({ children, minHeight }) => (
  <div style={minHeight ? { minHeight } : undefined}>
    {children}
  </div>
)

export default LazySection
